import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Flex, A, FlexItem, Text } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { connect } from 'react-redux';

import { selectors, fetchMessages, markAsRead } from './state/reducer';
import { BroadcastMessagesProps, MapState, MapDispatch } from './types';

const { FormattedMessage } = Intl;

const BroadcastMessages: FC<BroadcastMessagesProps> = props => {
  const { fetchMessages, markAsRead, broadcastMessages } = props;
  const history = useHistory();

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const unreadMessages = broadcastMessages.filter(x => !x.read);
  if (!unreadMessages.length) return null;

  const unreadMessage = unreadMessages[0],
    afterClose = () => {
      const [, ...others] = broadcastMessages;
      markAsRead([...others, { ...unreadMessage, read: true }]);
    },
    learnMoreHandler = () =>
      history.push({
        pathname: `/broadcastmessage/${unreadMessage.id}`,
        search: history.location.search,
        state: {
          modal: true,
          message: unreadMessage,
        },
      }),
    message = (
      <Flex>
        <FlexItem overflow="hidden">
          <Text
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            overflow="hidden"
            color={unreadMessage.colors.fontColor}
          >
            <b>{unreadMessage.title} </b>
            {unreadMessage.summary}
          </Text>
        </FlexItem>
        <Flex justify="flex-end">
          <A onClick={learnMoreHandler} color={unreadMessage.colors.fontColor}>
            <Text
              whiteSpace="nowrap"
              textDecoration="underline"
              color={unreadMessage.colors.fontColor}
            >
              <FormattedMessage
                id={messageIds.vms.broadcastMessages.learnMore}
              />
            </Text>
          </A>
        </Flex>
      </Flex>
    );

  return (
    <Alert
      key={unreadMessage.id}
      color={unreadMessage.colors.alertColor}
      afterClose={afterClose}
      message={message}
      closable
    ></Alert>
  );
};

const mapStateToProps: MapState = state => ({
  broadcastMessages: selectors.selectBroadcastMessages(state).messages,
});

const mapDispatchToProps: MapDispatch = {
  fetchMessages,
  markAsRead,
};

export default connect(mapStateToProps, mapDispatchToProps)(BroadcastMessages);
